import { formatDate } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from 'src/app/blacklist/service/data.service';
import { BackendApiService } from 'src/app/service/backendapi.service';
import { EndpointsService } from 'src/app/service/endpoints.service';

@Component({
  selector: 'app-rrms-day-wise-reports',
  templateUrl: './rrms-day-wise-reports.component.html',
  styleUrls: ['./rrms-day-wise-reports.component.scss']
})
export class RrmsDayWiseReportsComponent implements OnInit {
  @Output() refreshTableData = new EventEmitter();
  rrmsDayWiseReports: FormGroup;
  loadPage: boolean;
  loadTable = false;
  showTable: boolean;
  subscriberInfoData: [];
  updateFlag = false;
  submitted = false;
  reportData: [];
  vpmnCountryList: any;
  vpmnNetworkList: any;
  callVPMNNetwork: boolean;
  

  constructor(private spinnerService: Ng4LoadingSpinnerService, private dataService: DataService,
    private formBuilder: FormBuilder, private router: Router,
    private endpointsService: EndpointsService, private dialog: MatDialog,
    private backendApiService: BackendApiService) { }

  ngOnInit(): void {
    this.spinnerService.show();
    this.createDayWiseReportsForm();
    this.getVPMNCountryDetails();
   // this.storeAnalytics();
    this.loadPage = true;
  }

  createDayWiseReportsForm() {
    this.rrmsDayWiseReports = this.formBuilder.group({
      VPMNCountry: [''],
      VPMNnetwork: [''],
      startDate: [],
      endDate: [],
      status: ['']
    });
  }

  changeDateEvent(targetCalendarId: any) {
    targetCalendarId.toggle();
  }

  get f() {
    return this.rrmsDayWiseReports.controls;
  }

  onSearch(){
    this.showTable = false;
    if (this.rrmsDayWiseReports.get('startDate').value != null && this.rrmsDayWiseReports.get('endDate').value != null) {

      if (this.rrmsDayWiseReports.get('startDate').value <= this.rrmsDayWiseReports.get('endDate').value) {
        this.spinnerService.show();

        const apiUrl = this.endpointsService.URL_GET_RRMS_DAY_WISE_REPORTS +
        '&country=' + this.rrmsDayWiseReports.get('VPMNCountry').value +
          '&network=' + this.rrmsDayWiseReports.get('VPMNnetwork').value +
          '&startDate=' + this.dateFormate(this.rrmsDayWiseReports.value.startDate) +
          '&endDate=' + this.dateFormate(this.rrmsDayWiseReports.value.endDate) +
          '&status=' + this.rrmsDayWiseReports.get('status').value +
          '&userOrgId=' + sessionStorage.getItem('userOrgId');


        this.backendApiService.callToApi(apiUrl).subscribe(response => {
          if (response === null)
            return;

          this.reportData = response;
          this.showTable = true;
          this.spinnerService.hide();
        });
      }
      else {
        alert('End Date cannot be less than Start Date');
        return;
      }
    } else {
      alert("Please select start date and end date.")
    }
    this.storeAnalytics();
  }

  onReset(){
    this.spinnerService.show();
    this.createDayWiseReportsForm();
    this.showTable = false;
    this.storeAnalytics1();
  }

  dateFormate(date) {
    return formatDate(date, 'yyyy-MM-dd HH:mm', 'en');
  }

  async getVPMNCountryDetails() {
    this.spinnerService.show();
    const apiUrl = this.endpointsService.COUNTRY_DETAILS + '&userName=' + sessionStorage.getItem('ecowas_user_name');
    this.backendApiService.callToApi(apiUrl).subscribe(response => {
      this.vpmnCountryList = response;
    });
  }

  getVpmnNetworkAccordingToCountry(event: any) {
    if (event.target.value === 'ALL') {
      // this.callVPMNNetwork = false;
      this.rrmsDayWiseReports.controls.VPMNnetwork.setValue('ALL', { onlySelf: true });
    } else {
      this.spinnerService.show();
      this.getVpmnNetworkList(event.target.value).then();
    }
  }

  async getVpmnNetworkList(country: string) {
    const apiUrl1 = this.endpointsService.URL_GET_OPERATOR_LIST_BY_COUNTRY +
      '&userName=' + sessionStorage.getItem('ecowas_user_name') + '&country=' + country;
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
      this.vpmnNetworkList = response;
      if (this.vpmnNetworkList && this.vpmnNetworkList.length > 0) {
        this.rrmsDayWiseReports.controls.VPMNnetwork.setValue(response[0].operator, { onlySelf: true });
      }

    });
  }
  async storeAnalytics() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=RRMS Day Wise Reports' + '&operation=search';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });

  }
  storeAnalytics1() {
    
    const apiUrl1 = this.endpointsService.CENTRY_LOG +
      'userName=' + sessionStorage.getItem('ecowas_user_name') + '&action=Reports' + '&module=RRMS Day Wise Reports' + '&operation=reset';
    this.backendApiService.callToApi(apiUrl1).subscribe(response => {
     console.log(response);
    });

  }



}
